<template>
  <!-- Gold specks drifting up through the room's light (mystic room
       2026-10-30): CSS only, 7 to 13s each, endless. None with reduced motion. -->
  <div class="room-motes" aria-hidden="true">
    <i v-for="m in motes" :key="m.i" :style="m.style"></i>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({ count: { type: Number, default: 9 } })
const motes = computed(() => Array.from({ length: props.count }, (_, i) => ({
  i,
  style: {
    left: `${8 + (i * 83) % 84}%`,
    '--dx': `${(i % 2 ? 1 : -1) * (6 + (i * 7) % 18)}px`,
    animationDuration: `${7 + (i * 3) % 7}s`,
    animationDelay: `-${(i * 1.7).toFixed(1)}s`,
  },
})))
</script>

<style scoped>
.room-motes { position: absolute; pointer-events: none; }
.room-motes i {
  position: absolute; bottom: 18%; width: 3px; height: 3px; border-radius: 50%; background: #ffe6ad;
  box-shadow: 0 0 6px 1px rgba(255, 220, 150, 0.7); opacity: 0; animation: room-mote linear infinite;
}
@keyframes room-mote {
  0% { opacity: 0; transform: translate(0, 0); }
  15% { opacity: 0.85; }
  70% { opacity: 0.5; }
  100% { opacity: 0; transform: translate(var(--dx), -150px); }
}
@media (prefers-reduced-motion: reduce) {
  .room-motes { display: none; }
}
</style>
